import Image from 'next/image';

type ImageProps = {
  src: string;
  alt: string;
  width: number;
  height: number;
  className?: string;
  style?: React.CSSProperties;
};

export const DMImage = ({ src, alt, className, width, height, style }: ImageProps) => {
  return (
    <Image
      src={src}
      className={className}
      width={width}
      height={height}
      style={style}
      loading='eager'
      alt={alt || 'Debug Media Image'}
    />
  );
};
